import Ajax from '../js/common/ajax';

export default {
    // 报表定义列表
    list(params = {}) { return Ajax.get('/bi', params); },
    load(id) { return Ajax.get(`/bi/${id}`); },
    delete(id) { return Ajax.delete(`/bi/${id}`); },
    save(params = {}) { return Ajax.post('/bi', params); },
    update(params = {}) { return Ajax.put('/bi', params); },
    // 取数公式计算
    compute(params = {}) { return Ajax.post('/bi/compute', params); },
    // 科目编码参照
    subjects(params = {}) { return Ajax.get('/bi/subjects', params); },
    // 辅助核算编码参照
    auxiliaries() { return Ajax.get('/bi/auxiliaries'); },
    // 复制
    copy(params = {}) { return Ajax.post('/bi/copy', params); },
    // 重命名
    rename(params = {}) { return Ajax.post('/bi/rename', params); }
};
